<template>
  <v-layout
    row
    wrap
  >
    <v-flex
      xs12
      class="text-right"
    >
      <project-filters
        v-model="filters"
        storage-key="projectFilters"
      />

      <v-btn
        v-if="$can('project.create')"
        color="primary"
        text
        :to="{ name: 'project-new' }"
        class="ml-3"
      >
        <v-icon left>
          add
        </v-icon>
        {{ $t('create') }}
      </v-btn>
    </v-flex>

    <v-flex
      v-for="project in filteredProjects.models"
      :key="`project-${project.id}`"
      xl2
      lg3
      md4
      sm4
      xs12
    >
      <project-card :project="project" />
    </v-flex>

    <v-flex
      v-if="projects.loading"
      xl2
      lg3
      md4
      sm4
      xs12
    >
      <v-skeleton-loader
        loading
        transition="scale-transition"
        type="card"
      />
    </v-flex>

    <v-flex v-else-if="!projects.length">
      <div
        v-t="'projects.none'"
        class="text-center grey--text"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import ProjectCard from '@/components/project/ProjectCard'
import ProjectFilters from '@/components/project/ProjectFilters'

import Projects from '@/models/Projects'

export default {
  name: 'Projects',
  components: {
    ProjectCard,
    ProjectFilters
  },
  data () {
    return {
      filters: {},
      projects: new Projects()
    }
  },
  computed: {
    filteredProjects () {
      return this.projects.filter(project => {
        let ret = true

        for (let prop in this.filters) {
          if (this.filters[prop] === null ||
              this.filters[prop] === undefined ||
              this.filters[prop].length === 0) {
            // Empty filter
            continue
          } else if (this.filters[prop] && this.filters[prop].length) {
            // If filter is Array (multiple values allowed)
            ret &= this.filters[prop].indexOf(project[prop]) > -1
          } else if (this.filters[prop]) {
            // If filter is String (single value allowed)
            ret &= this.filters[prop] === project[prop]
          }
        }

        return ret
      })
    }
  },
  async mounted () {
    await this.projects.fetch({
      organization: this.$currentOrganization.id
    })
  }
}
</script>
